// @ts-nocheck
import { Angulartics2RouterlessModule } from 'angulartics2/routerlessmodule';
import { CommonModule, DatePipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie-service';
import { NgxPictureModule, DEFAULT_BREAKPOINTS } from 'ngx-picture';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { OriginInterceptor } from './interceptor/origin.interceptor';
import { PreconditionFailedInterceptor } from './interceptor/precondition-failed.interceptor';
import { RefreshTokenInterceptor } from './interceptor/refresh-token.interceptor';
import { UI_KIT_COMPONENTS } from './component/index';
import { UI_KIT_DIRECTIVES } from './directive/index';
import { UI_KIT_PIPES } from './pipe/index';
import { UI_KIT_SERVICES } from './service/index';
import { UIKit } from './ui-kit';
import { UIKitIconRegistry } from './icon/icon.registry';
import { UIKitIllustrationRegistry } from './illustration/illustration.registry';
import { VersionInterceptor } from './interceptor/version.interceptor';
import { UiKitService } from './ui-kit.service';

const COMMON = [];

@NgModule({
  imports: [
    ...COMMON,
    CommonModule,
    HttpClientModule,
    FormsModule,
    NgxWebstorageModule.forRoot(),
    // RouterModule.forRoot([]), // <-- the consuming app has to define this
    Angulartics2RouterlessModule.forRoot(),
    ReactiveFormsModule,
    NgxPictureModule.forRoot({
      breakpoints: DEFAULT_BREAKPOINTS,
      srcInterpolator(value) {
        return value;
      },
    }),
    DropzoneModule,
  ],
  declarations: [
    //
    ...UI_KIT_PIPES,
    ...UI_KIT_COMPONENTS,
    ...UI_KIT_DIRECTIVES,
  ],
  exports: [
    //
    ...COMMON,
    ...UI_KIT_PIPES,
    ...UI_KIT_COMPONENTS,
    ...UI_KIT_DIRECTIVES,
  ],
})
export class UiKitModule {
  constructor(iconRegistry: UIKitIconRegistry, illustrationRegistry: UIKitIllustrationRegistry) {
    iconRegistry.registerIcons([]);
    illustrationRegistry.registerIllustrations([]);
  }

  static forRoot(config: UIKit.UIKITConfig): ModuleWithProviders<UiKitModule> {
    return {
      ngModule: UiKitModule,
      providers: [
        CookieService,
        UiKitService,
        DatePipe,
        ...UI_KIT_SERVICES,
        { provide: 'config', useValue: config },
        { provide: 'environment', useValue: config.environment },
        { provide: 'application', useValue: config.application },
        { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: VersionInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: PreconditionFailedInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: OriginInterceptor, multi: true },
      ],
    };
  }
}
